import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Trash2, Shield, ShieldOff } from "lucide-react";
import { toast } from "sonner";

export default function AdminUsers() {
  const [users, setU] = useState([]);
  const [q, setQ] = useState("");
  const load = () => api.get("/admin/users").then(r => setU(r.data));
  useEffect(() => { load(); }, []);

  const updatePlan = async (uid, plan) => {
    await api.put(`/admin/users/${uid}`, { plan });
    toast.success("Plan updated");
    load();
  };
  const toggleAdmin = async (u) => {
    await api.put(`/admin/users/${u.uid}`, { isAdmin: !u.isAdmin });
    toast.success(`Admin ${!u.isAdmin ? "granted" : "revoked"}`);
    load();
  };
  const del = async (uid) => {
    if (!window.confirm("Delete user permanently?")) return;
    await api.delete(`/admin/users/${uid}`);
    toast.success("User deleted");
    load();
  };

  const filtered = users.filter(u => !q || u.email.includes(q) || (u.displayName||"").toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14">
      <div className="flex items-center gap-3">
        <span className="px-2 py-1 rounded-md bg-red-500/20 border border-red-500/40 text-red-300 text-[10px] tracking-widest uppercase">ADMIN</span>
      </div>
      <h1 className="mt-2 text-3xl font-bold tracking-tight" style={{fontFamily:"'Cabinet Grotesk', sans-serif"}}>Users</h1>
      <Input data-testid="admin-users-search" placeholder="Search by name or email…" value={q} onChange={e=>setQ(e.target.value)} className="mt-4 max-w-md"/>

      <div className="mt-6 glass-strong rounded-2xl overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full min-w-[640px] text-sm">
          <thead className="text-xs uppercase tracking-widest text-zinc-400 bg-white/[0.02]">
            <tr><th className="text-left px-5 py-3">User</th><th className="text-left px-3 py-3">Plan</th><th className="text-left px-3 py-3">Docs</th><th className="text-left px-3 py-3">Joined</th><th className="text-left px-3 py-3">Admin</th><th className="text-right px-5 py-3">Actions</th></tr>
          </thead>
          <tbody>
            {filtered.map(u => (
              <tr key={u.uid} className="border-t border-white/[0.05]">
                <td className="px-5 py-3">
                  <div className="font-medium">{u.displayName}</div>
                  <div className="text-xs text-zinc-500">{u.email}</div>
                </td>
                <td className="px-3 py-3">
                  <select value={u.plan} onChange={e=>updatePlan(u.uid, e.target.value)} className="bg-white/[0.05] rounded px-2 py-1 text-xs border border-white/[0.1]" data-testid={`admin-plan-${u.uid}`}>
                    <option value="free">Free</option><option value="pro">Pro</option><option value="business">Business</option>
                  </select>
                </td>
                <td className="px-3 py-3">{u.totalDocumentsScanned || 0}</td>
                <td className="px-3 py-3 text-zinc-400">{(u.createdAt||"").split("T")[0]}</td>
                <td className="px-3 py-3">{u.isAdmin && <span className="text-xs text-red-300">YES</span>}</td>
                <td className="px-5 py-3">
                  <div className="flex items-center justify-end gap-1">
                    <button onClick={() => toggleAdmin(u)} className="p-1.5 rounded hover:bg-white/10" title={u.isAdmin?"Revoke admin":"Grant admin"}>
                      {u.isAdmin ? <ShieldOff size={14}/> : <Shield size={14}/>}
                    </button>
                    <button onClick={() => del(u.uid)} className="p-1.5 rounded hover:bg-red-500/20 text-red-400"><Trash2 size={14}/></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
}
